import React, { useLayoutEffect, useRef } from 'react';
export var ToolbarKeyboardNavigationProvider = function ToolbarKeyboardNavigationProvider(_ref) {
  var children = _ref.children,
    childComponentSelector = _ref.childComponentSelector,
    dom = _ref.dom,
    isShortcutToFocusToolbar = _ref.isShortcutToFocusToolbar,
    handleFocus = _ref.handleFocus,
    handleEscape = _ref.handleEscape,
    ariaLabel = _ref.ariaLabel,
    ariaControls = _ref.ariaControls;
  var wrapperRef = useRef(null);
  useLayoutEffect(function () {
    if (!wrapperRef.current) {
      return;
    }
    var element = wrapperRef.current;
    var handleKeyDown = function handleKeyDown(event) {
      var targetElement = event.target;
      if (targetElement instanceof HTMLElement && !targetElement.closest("".concat(childComponentSelector))) {
        return;
      }
      switch (event.key) {
        case 'Escape':
          handleEscape(event);
          break;
        default:
      }
    };
    var globalKeyDownHandler = function globalKeyDownHandler(event) {
      if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) {
        handleFocus(event);
      }
    };

    // ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    element === null || element === void 0 || element.addEventListener('keydown', handleKeyDown);
    // ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    dom === null || dom === void 0 || dom.addEventListener('keydown', globalKeyDownHandler);
    return function () {
      // ignored via go/ees005
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      element === null || element === void 0 || element.removeEventListener('keydown', handleKeyDown);
      // ignored via go/ees005
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      dom === null || dom === void 0 || dom.removeEventListener('keydown', globalKeyDownHandler);
    };
  }, [wrapperRef, childComponentSelector, dom, isShortcutToFocusToolbar, handleFocus, handleEscape]);
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
    className: "custom-key-handler-wrapper",
    ref: wrapperRef,
    "aria-label": ariaLabel,
    "aria-controls": ariaControls
  }, children);
};